/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ViewAgendaOutlinedIcon from '@material-ui/icons/ViewAgendaOutlined';
import PeopleOutlinedIcon from '@material-ui/icons/PeopleOutlined';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';

import Apresentacao from '../sections/Apresentacao';
import Parceiros from '../sections/Parceiros';
import Produto from '../sections/Produto';
import Configuracoes from '../sections/Configuracoes';

const sections = [
  { label: 'Apresentação', icon: <ViewAgendaOutlinedIcon />, component: Apresentacao },
  { label: 'Parceiros', icon: <PeopleOutlinedIcon />, component: Parceiros },
  { label: 'Produto', icon: <ShoppingCartOutlinedIcon />, component: Produto },
  { label: 'Configurações', icon: <SettingsOutlinedIcon />, component: Configuracoes },
];

const VendasOnlineParceiroTabs = ({
  value,
  handleNativeChange,
  formValues,
  handleOpenConfirmation,
  handleCancelClose,
  openConfirmation,
  setOpenConfirmation,
  onClickProgress,
  goBack,
  closeModal,
  router,
  location,
  editMode,
  activityId,
}) => {
  const Section = sections[value].component;

  const prev = () => {
    handleNativeChange(null, Math.max(0, value - 1));
  };

  const handleNext = () => {
    // Salvar antes de avançar para a próxima aba
    if (onClickProgress) {
      onClickProgress();
    }
  };

  return (
    <Box style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          padding: '8px 16px',
        }}
      >
        <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {sections[value].icon}
          <Typography variant="subtitle2" style={{ fontWeight: 500, fontSize: 16 }}>
            {sections[value].label}
          </Typography>
        </Box>

        <Box style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <Typography variant="caption">
            {value + 1} de {sections.length}
          </Typography>
          <IconButton size="small" onClick={prev} disabled={value === 0}>
            <ChevronLeftIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={handleNext}
            disabled={value === sections.length - 1}
          >
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      <Box style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
        <Section
          formValues={formValues}
          handleOpenConfirmation={handleOpenConfirmation}
          handleCancelClose={handleCancelClose}
          openConfirmation={openConfirmation}
          setOpenConfirmation={setOpenConfirmation}
          onClickProgress={onClickProgress}
          goBack={goBack}
          closeModal={closeModal}
          router={router}
          location={location}
          handleNativeChange={handleNativeChange}
          value={value}
          editMode={editMode}
          activityId={activityId}
          confirmationTitle="Deseja sair da edição?"
          confirmationSubtitle="Lembre-se, as informações que não foram salvas serão perdidas."
          buttonConfirmationLabel="Sim, sair da edição"
        />
      </Box>
    </Box>
  );
};

VendasOnlineParceiroTabs.propTypes = {
  value: PropTypes.number.isRequired,
  handleNativeChange: PropTypes.func.isRequired,
  formValues: PropTypes.object,
  handleOpenConfirmation: PropTypes.func.isRequired,
  handleCancelClose: PropTypes.func.isRequired,
  openConfirmation: PropTypes.bool.isRequired,
  setOpenConfirmation: PropTypes.func.isRequired,
  onClickProgress: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  editMode: PropTypes.bool,
  activityId: PropTypes.number,
};

export default VendasOnlineParceiroTabs;
